exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_navigationBarContentWrapper_3kMavZqaHrKo5V5Kr5ZFcw {\n  display: flex;\n  height: 100%;\n  flex-direction: row-reverse;\n  align-Items: center;\n}\n\n.IA_templateEditorWrapper_1zMOZLsDwKOL0zIvsSs3CY {\n  display: flex;\n  flex-direction: column;\n  padding: 0 40px;\n}\n\n.IA_createTemplateButtonWrapper_2xpfh_VfevxA1qF8SXsCjF {\n  margin-top: 25px;\n}", ""]);

// Exports
exports.locals = {
	"IA_navigationBarContentWrapper": "IA_navigationBarContentWrapper_3kMavZqaHrKo5V5Kr5ZFcw",
	"IA_templateEditorWrapper": "IA_templateEditorWrapper_1zMOZLsDwKOL0zIvsSs3CY",
	"IA_createTemplateButtonWrapper": "IA_createTemplateButtonWrapper_2xpfh_VfevxA1qF8SXsCjF"
};